<template>
  <section class="section section-shaped section-lg my-0" id="loginComponent">
    <!-- <nav class="navbar navbar-light bg-graynav">
      <a class="navbar-brand" href="\">
        <img width="50" height="50" src="img/arc360_icon.png">
      </a>
    </nav> -->
    <br>
    <br>
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="spacerAbove">
        </div>
        <div >
          <b-img id="loginLabel" src="img/TopRibbon3_orange_white.png"></b-img>
        </div>
        <div class="spacerBelow">
        </div>
        
      </div>
    </div>
  </section>
</template>
<script>

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password:""
    }
  },
  methods: {
    triggerSignInProcess: function() {
      const current = this
      if (current.validateSignInRequirements()) {
        let data = {
          username: current.email,
          password: current.password
        }
        current.$store.dispatch("mainStore/login", data).then(token=>{
          sessionStorage.setItem("accessToken", token)
          current.$store.commit("mainStore/storeAccessToken", token)
          current.$notify({
            group: 'notification_01',
            title: 'Login Successful',
            text: '',
            type: "success",
            duration: 1500
          });
          current.$router.push("/LandingPage")
        }).catch(error=>{
          console.log(error);
          current.$notify({
            group: 'notification_01',
            title: 'Login Failed',
            text: 'Kindly check your credentials for any mistakes.',
            type: "error"
          });
        });
      }
      else {
        current.$notify({
          group: 'notification_01',
          title: 'Login Failed',
          text: 'Kindly check your credentials for any mistakes.',
          type: "error"
        });
      }
    },
    validateSignInRequirements: function() {
      if (this.email!="" && this.password!="") {
        return true
      }
      else {
        return false;
      }
    }
  }
};
</script>
<style>
#loginComponent {
  height: 87vh!important;
}
.spacerAbove {
  height: 24vh;
  width: 100vw!important;
}
.spacerBelow {
  height: 2vh;
  width: 100vw!important;
}
#loginLabel {
  height: 10vh!important;
}
.transparentCard {
   /* background: rgba(89, 88, 88, 0.75)!important; */
   background: rgba(128, 128, 128, 0.5);
}
.innerOpacity {
  opacity: 1!important;
 
}
</style>
